import { combineGuardsParallel } from '../../composer/combineGuardsParallel';
import { combineGuardsSerial } from '../../composer/combineGuardsSerial';
import { checkValidTokenGuard } from '../../guards/account/checkValidTokenGuard';
import { determineAccountLanguageGuard } from '../../guards/account/determineAccountLanguageGuard';
import { determineI18nResourceGuard } from '../../guards/determineI18nResourceGuard';

import type { AnyOfGuard } from '../../../types';

const baseGuardArray = [
  // 1단계: 토큰 검증 + 언어 결정 (병렬 실행)
  combineGuardsParallel([checkValidTokenGuard, determineAccountLanguageGuard]),
  // 2단계: i18n 리소스 로드 (language에 의존하므로 순차 실행)
  determineI18nResourceGuard,
];

export const generateInitialServerSideGuards = (additionalGuards?: AnyOfGuard[]) => {
  const additions = additionalGuards ?? [];

  return combineGuardsSerial([...baseGuardArray, ...additions]);
};
